import { render } from "./Dropdown.vue?vue&type=template&id=c642fa0c&scoped=true&lang=true"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"

import "./Dropdown.vue?vue&type=style&index=0&id=c642fa0c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c642fa0c"]])

export default __exports__